
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_p3uaw_5",
  "button": "awsui_button_vjswe_p3uaw_9",
  "variant-normal": "awsui_variant-normal_vjswe_p3uaw_29",
  "is-activated": "awsui_is-activated_vjswe_p3uaw_42",
  "variant-icon": "awsui_variant-icon_vjswe_p3uaw_69",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_p3uaw_69",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_p3uaw_69",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_p3uaw_87",
  "disabled": "awsui_disabled_vjswe_p3uaw_105",
  "variant-primary": "awsui_variant-primary_vjswe_p3uaw_113",
  "variant-link": "awsui_variant-link_vjswe_p3uaw_197",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_p3uaw_617",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_p3uaw_704",
  "button-no-text": "awsui_button-no-text_vjswe_p3uaw_788",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_p3uaw_792",
  "icon-left": "awsui_icon-left_vjswe_p3uaw_808",
  "icon-right": "awsui_icon-right_vjswe_p3uaw_813",
  "icon": "awsui_icon_vjswe_p3uaw_808"
};
  